import Interface from '@components/ui/interface.vue';
import Fastbuy from '@components/ui/fastBuy.vue';
import SecondMenu from '@components/second-menu/script.js';

import { mapMutations, mapState, mapActions } from 'vuex';

export default {
  data: function() {
    return {
      windowPosition: 0,
      visible: true,
    };
  },
  components: {
    Interface,
    Fastbuy,
    'second-menu-cmp': SecondMenu,
  },
  computed: {
    ...mapState('api', ['callback']),
    ...mapState('params', ['mobile', 'leftMenu']),
    isHide() {
      return this.mobile && this.leftMenu;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.setVisible);
  },
  destroyed: function() {
    window.removeEventListener('scroll', this.setVisible);
  },
  methods: {
    ...mapMutations('params', [
      'openleftMenu',
      'toogleCallBackForm',
      'toggleRightMenu',
    ]),
    ...mapActions('api', ['fetchRequest']),

    setVisible: function() {
      if (window.pageYOffset > this.$refs['header-menu'].clientHeight / 2) {
        this.windowPosition - window.pageYOffset < 0
          ? this.$refs['header-menu'].classList.remove('visible')
          : this.$refs['header-menu'].classList.add('visible');
        this.windowPosition = window.pageYOffset;
      } else this.$refs['header-menu'].classList.add('visible');
    },
    phoneFormat: function(value) {
      return value.replace(/\s/g, '');
    },
    callBack: function() {
      this.toogleCallBackForm();
      this.toggleRightMenu();
    },
  },
};



// WEBPACK FOOTER //
// ./src/templates/components/header-menu/script.js